import SelectRepresentation from '../../views/SelectRepresentation.vue';
import Eiendomsskatt from '../../views/Eiendomsskatt.vue';

const baseRoutes = (guardNavigation) => [
  {
    path: '/',
    name: 'SelectRepresentation',
    component: SelectRepresentation,
    beforeEnter: guardNavigation,
  },
  {
    path: '/oversikt',
    name: 'Eiendomsskatt',
    component: Eiendomsskatt,
    beforeEnter: guardNavigation,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
    beforeEnter: guardNavigation,
  },
];

export default baseRoutes;
